module.exports = __webpack_public_path__ + "static/media/KGantin-96-27.8c679ecd.jpg";